import React, { useMemo } from 'react';

import classnames from 'classnames';

import Typography from 'components/uiLibrary/Typography';

import { usePaywallContext } from 'components/Paywall';
import WorkTypeTag from 'components/Work/Display/WorkTypeTag';

import { getProductionWorkTypeTag } from 'utils/productions';

import classes from './ProductionTags.module.scss';

const ProductionTags = ({ data, isFeaturedCard }) => {
  const { setIsPaywallExpanded } = usePaywallContext();
  const isArchived = data?.isArchived;
  const stagingType =
    data?.productionWorkTypes?.[0]?.stagingType ||
    data?.productionWorks?.[0]?.productionWorkToWorkTypes?.[0]?.stagingType;

  const workTypeTag = useMemo(() => getProductionWorkTypeTag(data), [data]);

  return (
    <div className={classnames(classes.tags, { [classes.tags__featuredCard]: isFeaturedCard })}>
      <WorkTypeTag tag={workTypeTag} className={classes.workTag} />
      {stagingType?.name && (
        <Typography
          size={12}
          color="secondary"
          italic
          truncate
          className={classnames(classes.stagingType, {
            [classes.stagingType__featuredCard]: isFeaturedCard,
          })}
          blur={isArchived}
          {...(isArchived && {
            onClick: e => {
              e.stopPropagation();
              e.preventDefault();
              setIsPaywallExpanded(true);
            },
          })}
        >
          {stagingType?.name}
        </Typography>
      )}
    </div>
  );
};

export default ProductionTags;
